var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6021 42.6029H35.1937V31.0007C35.1937 28.2341 35.1443 24.6726 31.3406 24.6726C27.482 24.6726 26.8916 27.6871 26.8916 30.7994V42.6021H19.4833V18.7435H26.5953V22.0041H26.6949C27.4066 20.7871 28.4351 19.7859 29.6708 19.1072C30.9065 18.4285 32.3032 18.0977 33.7121 18.15C41.2209 18.15 42.6052 23.089 42.6052 29.5144L42.6021 42.6029ZM11.124 15.4824C8.74956 15.4828 6.82437 13.5582 6.82397 11.1837C6.82358 8.80933 8.748 6.88413 11.1224 6.88374C13.4968 6.88316 15.422 8.80777 15.4224 11.1822C15.4226 12.3224 14.9699 13.416 14.1638 14.2225C13.3577 15.0289 12.2642 15.4821 11.124 15.4824ZM14.8283 42.6031H7.41206V18.7435H14.8281V42.6029L14.8283 42.6031ZM46.2955 0.00347119H3.6894C1.67573 -0.0191851 0.0243652 1.5939 -0.000244141 3.60757V46.3914C0.023584 48.406 1.67476 50.0207 3.68921 49.9996H46.2955C48.3142 50.0246 49.9718 48.4099 49.9998 46.3914V3.60425C49.971 1.58667 48.3132 -0.0262163 46.2955 0.000150882",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosLinkedinIcon);
export default __webpack_public_path__ + "static/media/logos_linkedin-icon.b603738fab6dcb90a721e137809e646f.svg";
export { ForwardRef as ReactComponent };